import { Component, Input } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';

@Component({
  selector: 'subs-departmental-admin',
  templateUrl: './departmental-admin.component.html',
})
export class DepartmentalAdminComponent {
  @Input() form: UntypedFormGroup;
}
